export let language_vi = {
  translation: {
    language: "Tiếng việt",
    home: {
      helloWorld: "Xin chào thế giới !",
      seeDetails: "Xem chi tiết",
      detail: "Chi tiết trang chủ...",
    },
    menu: {},
  },
};
